import { render, staticRenderFns } from "./article_edit.vue?vue&type=template&id=707fa010&style=true"
import script from "./article_edit.vue?vue&type=script&lang=js"
export * from "./article_edit.vue?vue&type=script&lang=js"
import style0 from "./article_edit.vue?vue&type=style&index=0&id=707fa010&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports